
import { mapState } from 'vuex';

export default {
  i18nComponentKey: 'ReviewPrompt.components.MultipleReviewBody',
  name: 'MultipleReviewBody',
  props: {
    subOrders: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState('window', ['windowService']),
    ...mapState('reviewSettings', ['reviewSettings', 'reviewPromptSettings']),
    showSubBrandName() {
      return (
        this.reviewSettings.use_sub_brand_filter_setting &&
        this.subOrders[0].product.sub_brand_name
      );
    },
    endDate() {
      if (!this.subOrders[0].pending_review_expires_in) return;

      return this.$t('pending_review.end_date', {
        end_date: this.subOrders[0].pending_review_expires_in,
        remaining_days: this.subOrders[0].remaining_days
      });
    },
    buttonStyle() {
      return {
        '--btn-bg-color': this.reviewSettings.new_review_popup_button_color,
        '--btn-text-color': this.reviewSettings
          .new_review_popup_button_text_color
      };
    },
    writeButtonLabel() {
      if (!this.reviewPromptSettings.write_review_button_label)
        return this.$t('write_review');

      return this.reviewPromptSettings.write_review_button_label.replace(
        /%{mileage_type_point_text}/g,
        this.reviewSettings.mileage_type_point_text
      );
    }
  }
};
